import $ from 'jquery';
import Change from './Change';

const defaults = {
  speed: 0.35,
};

export default class Parallax {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign(defaults, options);
    this.register();
    this.update();
  }

  register() {
    Change.onChange(this.update.bind(this));
  }

  update() {
    const offset = window.pageYOffset * this.settings.speed;
    this.$element.css('transform', `translate3d(0, ${offset}px, 0)`);
  }
}



// WEBPACK FOOTER //
// ./Parallax.js